import React from 'react';
import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from '@fluentui/react';

interface ConfirmationDialogProps {
    isOpen: boolean;
    title: string;
    message?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    isSubmitting?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    isOpen,
    title,
    message,
    confirmText = 'Odeslat',
    cancelText = 'Zrušit',
    onConfirm,
    onCancel,
    isSubmitting = false,
}) => {
    const dialogContentProps = {
        type: DialogType.largeHeader,
        title,
        closeButtonAriaLabel: 'Close',
    };

    return (
        <Dialog
            hidden={!isOpen}
            dialogContentProps={dialogContentProps}
            onDismiss={onCancel}
        >
            {message && <div style={{ marginBottom: 16 }}>{message}</div>}
            <DialogFooter>
                <PrimaryButton
                    text={confirmText}
                    onClick={onConfirm}
                    disabled={isSubmitting}
                />
                <DefaultButton
                    text={cancelText}
                    onClick={onCancel}
                    disabled={isSubmitting}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default ConfirmationDialog;
